module.exports = __webpack_public_path__ + "public/images/catalogue-stand-title.089e33e9c46e6ccaacd9ffeb2ab5ebb8.svg";